// extracted by mini-css-extract-plugin
export var downloadHeader = "Hero-module--downloadHeader--PAm9b";
export var headerImage = "Hero-module--headerImage--zdxcs";
export var titleContainer = "Hero-module--titleContainer--o7Pc+";
export var headerButtons = "Hero-module--headerButtons--yIrZ3";
export var manualButton = "Hero-module--manualButton---oocN";
export var downloadButton = "Hero-module--downloadButton--cCuOK";